const STATES = {
  NEW: 'NEW',
  CSR_LOADED: 'CSR_LOADED',
  CERT_SIGNED: 'CERT_SIGNED',
  INVALID: 'INVALID',
  VALID: 'VALID',
};

export { STATES };
